<template>
  <div style="height: 200px">
    <loader />
  </div>
</template>
<script>
import Loader from '../Loader.vue';
import { ACTION_AWAIT_REQUEST } from '../../store/action-types';
import { MUTATION_COMPOSITION_SET_COMPOSITION } from '../../store/modules/composition/mutation-types';
import { CREATOR_API } from '../../api/creator-api';
import { DEFAULT_PRODUCT } from '../../../utils/configure-environment';

export default {
  name: 'CompositionLoader',
  components: {
    Loader
  },
  async mounted() {
    let articleNumber = DEFAULT_PRODUCT;
    try {
      await this.$store.dispatch(ACTION_AWAIT_REQUEST, async () => {
        const result = await CREATOR_API.share.get(this.$route.params.uuid);

        articleNumber = result.articleNumber;
        this.$store.commit(
          MUTATION_COMPOSITION_SET_COMPOSITION,
          result.composition
        );
      });
    } catch (error) {
      this.$toasted.error(this.$t('share.sharelinkinvalid'), {
        duration: 5000
      });
    }
    this.$router.push({
      name: 'root',
      params: { articleNumber: articleNumber }
    });
  }
};
</script>
